//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { DateMixin } from '@/mixins/DateMixin';
export default {
  name: 'yearRangeMonth',
  mixins: [DateMixin],
  mounted: function mounted() {
    this.$emit('change', [this.startYear, this.endYear, this.monthFormatFun2(this.monthTime)]);
  },
  methods: {
    // 开始年变化
    handleChange: function handleChange(value) {
      this.startYear = value;
      var startTime = this.startYear;
      var endTime = this.endYear;

      if (startTime >= endTime) {
        this.startYear = '';
        this.$message.error('开始年必须小于结束年');
      }

      if (this.monthTime) {
        this.$emit('change', [this.startYear, this.endYear, this.monthFormatFun2(this.monthTime)]);
      }
    },
    // 结束年变化
    handleChange2: function handleChange2(value) {
      this.endYear = value;
      var startTime = this.startYear;
      var endTime = this.endYear;

      if (startTime >= endTime) {
        this.endYear = '';
        this.$message.error('开始年必须小于结束年');
      }

      if (this.monthTime) {
        this.$emit('change', [this.startYear, this.endYear, this.monthFormatFun2(this.monthTime)]);
      }
    },
    // 月份变化
    onMonthChange: function onMonthChange(date, dateString) {
      this.monthTime = date;

      if (this.startYear && this.endYear) {
        this.$emit('change', [this.startYear, this.endYear, dateString]);
      }
    }
  }
};